import { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import HeroSection from "../Components/HeroSection";
import Form from "../Components/Form";
import TitleContent from "../Components/TitleContent";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import { currentSite } from "../Config/siteConfig";

export default function Contactus() {
  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    // Set initial background image
    updateBackgroundImage();

    // Update background image on window resize
    window.addEventListener("resize", updateBackgroundImage);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <Header id={2} />

        <div className="w-full h-[25rem]  ">
          <HeroSection
            title1=""
            title2="Connect With Us"
            content={`At ${
              currentSite === "site1" ? "Qulabs" : "Quantum AI Global"
            }, we welcome your inquiries, ideas, and collaborations. As we build the foundation for the quantum era through advanced hardware, software, and secure systems, we’re actively collaborating with partners and growing our team. If you’re interested in working with us, exploring opportunities, or building the future of quantum and AI together with us.`}
          />
        </div>
        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center gap-2">
          {/* <TitleContent
            title="We are Happy to Assist,"
            content={`At ${
              currentSite === "site1" ? "Qulabs" : "Quantum AI Global"
            }, we are dedicated to helping organizations harness the full potential of quantum and AI technology. If you have any questions or would like to learn more about our products and services, please don’t hesitate to get in touch with us.`}
          /> */}

          <div className="w-full h-auto relative flex md:flex-row flex-col items-center justify-center px-5  lg:gap-10 gap-5  ">
            <div className="lg:w-[20%] w-[15rem] px-2  border-[0.06rem] border-[#444D61] flex flex-col items-center justify-center gap-1 h-[7.5rem] bg-black rounded-2xl">
              <div className="font-opensans font-normal text-[#1B99D4] text-sm xl:text-lg md:text-[1rem]">
                E mail
              </div>
              <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                {currentSite === "site1" ? "info@qulabs.ai" : "info@quantum.ai"}
              </div>
            </div>

            <div className="lg:w-[20%]  w-[15rem] px-2  border-[0.06rem] border-[#444D61] flex flex-col items-center justify-center gap-1 h-[7.5rem] bg-black rounded-2xl">
              <div className="font-opensans font-normal text-[#1B99D4] text-sm xl:text-lg md:text-[1rem]">
                Office Phone
              </div>
              <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                {currentSite === "site2"
                  ? "+1 (732) 227 4433"
                  : "+91 6281684342"}
              </div>
              <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                {currentSite === "site2"
                  ? "+91 8121027006"
                  : "+91 7386907570"}
              </div>
            </div>
            <div className="lg:w-[20%] w-[15rem] px-2 border-[0.06rem] border-[#444D61] flex flex-col items-center justify-center  gap-1 h-[7.5rem] bg-black  rounded-2xl">
              <div className="font-opensans font-normal text-[#1B99D4] text-sm xl:text-xl md:text-[1rem]">
                Office Timings
              </div>
              <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                Mon – Fri : 9.00am to 6.00pm
              </div>
              {/* <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                Sat : 10.00am to 5.00pm
              </div> */}
              <div className="font-opensans font-normal text-white  text-xs md:text-sm ">
                Sunday: Holiday
              </div>
            </div>
          </div>
        </div>
        <div className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 ">
          <Form />
        </div>
        <Footer showpage={true} />
      </div>
    </div>
  );
}
